namespace $ {
	export class $visavis_phase extends $mol_book2 {
		
		/**
		 * ```tree
		 * plot $visavis_plot
		 * ```
		 */
		@ $mol_mem
		plot() {
			const obj = new this.$.$visavis_plot()
			
			return obj
		}
		
		/**
		 * ```tree
		 * colors_by_nphases *
		 * 	1 \#d1cde6
		 * 	alt_1 \#9cf
		 * 	3 \#fc6
		 * 	4 \#FCD3C2
		 * 	5 \#CCE7D4
		 * 	default \#eee
		 * ```
		 */
		colors_by_nphases() {
			return {
				1: "#d1cde6",
				alt_1: "#9cf",
				3: "#fc6",
				4: "#FCD3C2",
				5: "#CCE7D4",
				default: "#eee"
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * line *
		 * 	phase * width 0.2
		 * 	compound *
		 * 		width 5
		 * 		color \#d1cde6
		 * 	default *
		 * 		width 0.5
		 * 		color \#666
		 * ```
		 */
		line() {
			return {
				phase: {
					width: 0.2
				} as Record< string, any >,
				compound: {
					width: 5,
					color: "#d1cde6"
				} as Record< string, any >,
				default: {
					width: 0.5,
					color: "#666"
				} as Record< string, any >
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * is_triangle false
		 * ```
		 */
		is_triangle() {
			return false
		}
		
		/**
		 * ```tree
		 * triangle *
		 * 	datamock / *
		 * 		a /
		 * 		b /
		 * 		c /
		 * 		type \scatterternary
		 * 	layout *
		 * 		hovermode \closest
		 * 		font *
		 * 			size 20
		 * 			color \#333
		 * 			family \Exo2
		 * 		ternary *
		 * 			aaxis *
		 * 				title <= json_title_a
		 * 				ticks \
		 * 				showline true
		 * 				showgrid false
		 * 				fixedrange true
		 * 				linewidth 1
		 * 			baxis *
		 * 				title <= json_title_b
		 * 				ticks \
		 * 				showline true
		 * 				showgrid false
		 * 				fixedrange true
		 * 				linewidth 1
		 * 			caxis *
		 * 				title <= json_title_c
		 * 				ticks \
		 * 				showline true
		 * 				showgrid false
		 * 				fixedrange true
		 * 				linewidth 1
		 * 		shapes <= layout_shapes
		 * 		annotations <= annotations
		 * ```
		 */
		triangle() {
			return {
				datamock: [
					{
						a: [
						] as readonly any[],
						b: [
						] as readonly any[],
						c: [
						] as readonly any[],
						type: "scatterternary"
					} as Record< string, any >
				] as readonly any[],
				layout: {
					hovermode: "closest",
					font: {
						size: 20,
						color: "#333",
						family: "Exo2"
					} as Record< string, any >,
					ternary: {
						aaxis: {
							title: this.json_title_a(),
							ticks: "",
							showline: true,
							showgrid: false,
							fixedrange: true,
							linewidth: 1
						} as Record< string, any >,
						baxis: {
							title: this.json_title_b(),
							ticks: "",
							showline: true,
							showgrid: false,
							fixedrange: true,
							linewidth: 1
						} as Record< string, any >,
						caxis: {
							title: this.json_title_c(),
							ticks: "",
							showline: true,
							showgrid: false,
							fixedrange: true,
							linewidth: 1
						} as Record< string, any >
					} as Record< string, any >,
					shapes: this.layout_shapes(),
					annotations: this.annotations()
				} as Record< string, any >
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * triangle_shape_fix *
		 * 	type \path
		 * 	path \M 0,0 L 0.5,0.866 L 1,0
		 * 	line * width 0
		 * ```
		 */
		triangle_shape_fix() {
			return {
				type: "path",
				path: "M 0,0 L 0.5,0.866 L 1,0",
				line: {
					width: 0
				} as Record< string, any >
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * triangle_annotations / *
		 * 	text <= triangle_annotation_text
		 * 	x: -0.25
		 * 	y: 0.96
		 * 	showarrow false
		 * 	xref \papper
		 * 	yref \papper
		 * 	font *
		 * 		size 15
		 * 		family \Exo2
		 * ```
		 */
		triangle_annotations() {
			return [
				{
					text: this.triangle_annotation_text(),
					"x:": -0.25,
					"y:": 0.96,
					showarrow: false,
					xref: "papper",
					yref: "papper",
					font: {
						size: 15,
						family: "Exo2"
					} as Record< string, any >
				} as Record< string, any >
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * rectangle *
		 * 	datamock /
		 * 		*
		 * 			x /
		 * 			y /
		 * 			type \scatter
		 * 			xaxis \x
		 * 			yaxis \y
		 * 		*
		 * 			x /
		 * 			y /
		 * 			type \scatter
		 * 			xaxis \x2
		 * 			yaxis \y2
		 * 	layout *
		 * 		hovermode \closest
		 * 		font *
		 * 			size 16
		 * 			color \#333
		 * 			family \Exo2
		 * 		xaxis *
		 * 			title \at. %
		 * 			range <= json_comp_range
		 * 			fixedrange true
		 * 			showticks <= show_ticks
		 * 			showline true
		 * 			zeroline false
		 * 			showgrid false
		 * 			ticklen 4
		 * 			tickfont * size 12
		 * 			hoverformat \.2r
		 * 		xaxis2 *
		 * 			range <= json_comp_range
		 * 			fixedrange true
		 * 			showticks <= show_ticks
		 * 			showline true
		 * 			zeroline false
		 * 			showgrid false
		 * 			ticklen 4
		 * 			tickfont * size 12
		 * 			side \top
		 * 			overlaying \x
		 * 		yaxis *
		 * 			title \T, &deg;C
		 * 			range <= json_temp
		 * 			fixedrange true
		 * 			showticks <= show_ticks
		 * 			showticklabels <= data_demo
		 * 			showline true
		 * 			zeroline false
		 * 			showgrid false
		 * 			ticklen 4
		 * 			tickfont * size 12
		 * 			hoverformat \.2r
		 * 		yaxis2 *
		 * 			range <= json_temp
		 * 			fixedrange true
		 * 			showticks <= show_ticks
		 * 			showticklabels <= data_demo
		 * 			showline true
		 * 			zeroline false
		 * 			showgrid false
		 * 			ticklen 4
		 * 			tickfont * size 12
		 * 			side \right
		 * 			overlaying \y
		 * 		shapes <= layout_shapes
		 * 		annotations <= annotations
		 * ```
		 */
		rectangle() {
			return {
				datamock: [
					{
						x: [
						] as readonly any[],
						y: [
						] as readonly any[],
						type: "scatter",
						xaxis: "x",
						yaxis: "y"
					} as Record< string, any >,
					{
						x: [
						] as readonly any[],
						y: [
						] as readonly any[],
						type: "scatter",
						xaxis: "x2",
						yaxis: "y2"
					} as Record< string, any >
				] as readonly any[],
				layout: {
					hovermode: "closest",
					font: {
						size: 16,
						color: "#333",
						family: "Exo2"
					} as Record< string, any >,
					xaxis: {
						title: "at. %",
						range: this.json_comp_range(),
						fixedrange: true,
						showticks: this.show_ticks(),
						showline: true,
						zeroline: false,
						showgrid: false,
						ticklen: 4,
						tickfont: {
							size: 12
						} as Record< string, any >,
						hoverformat: ".2r"
					} as Record< string, any >,
					xaxis2: {
						range: this.json_comp_range(),
						fixedrange: true,
						showticks: this.show_ticks(),
						showline: true,
						zeroline: false,
						showgrid: false,
						ticklen: 4,
						tickfont: {
							size: 12
						} as Record< string, any >,
						side: "top",
						overlaying: "x"
					} as Record< string, any >,
					yaxis: {
						title: "T, &deg;C",
						range: this.json_temp(),
						fixedrange: true,
						showticks: this.show_ticks(),
						showticklabels: this.data_demo(),
						showline: true,
						zeroline: false,
						showgrid: false,
						ticklen: 4,
						tickfont: {
							size: 12
						} as Record< string, any >,
						hoverformat: ".2r"
					} as Record< string, any >,
					yaxis2: {
						range: this.json_temp(),
						fixedrange: true,
						showticks: this.show_ticks(),
						showticklabels: this.data_demo(),
						showline: true,
						zeroline: false,
						showgrid: false,
						ticklen: 4,
						tickfont: {
							size: 12
						} as Record< string, any >,
						side: "right",
						overlaying: "y"
					} as Record< string, any >,
					shapes: this.layout_shapes(),
					annotations: this.annotations()
				} as Record< string, any >
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * rectangle_annotations /
		 * 	*
		 * 		text <= json_title_a
		 * 		x -0.03
		 * 		y -0.11
		 * 		showarrow false
		 * 		xref \papper
		 * 		yref \papper
		 * 		font *
		 * 			size 20
		 * 			family \Exo2
		 * 	*
		 * 		text <= json_title_b
		 * 		x 1.03
		 * 		y -0.11
		 * 		showarrow false
		 * 		xref \papper
		 * 		yref \papper
		 * 		font *
		 * 			size 20
		 * 			family \Exo2
		 * ```
		 */
		rectangle_annotations() {
			return [
				{
					text: this.json_title_a(),
					x: -0.03,
					y: -0.11,
					showarrow: false,
					xref: "papper",
					yref: "papper",
					font: {
						size: 20,
						family: "Exo2"
					} as Record< string, any >
				} as Record< string, any >,
				{
					text: this.json_title_b(),
					x: 1.03,
					y: -0.11,
					showarrow: false,
					xref: "papper",
					yref: "papper",
					font: {
						size: 20,
						family: "Exo2"
					} as Record< string, any >
				} as Record< string, any >
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * annotation *
		 * 	show_arrow false
		 * 	font *
		 * 		size 13
		 * 		family \Exo2
		 * ```
		 */
		annotation() {
			return {
				show_arrow: false,
				font: {
					size: 13,
					family: "Exo2"
				} as Record< string, any >
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * annotation_textangle* 0
		 * ```
		 */
		annotation_textangle(id: any) {
			return 0
		}
		
		/**
		 * ```tree
		 * plot_options *
		 * 	displaylogo false
		 * 	displayModeBar false
		 * 	staticPlot false
		 * ```
		 */
		plot_options() {
			return {
				displaylogo: false,
				displayModeBar: false,
				staticPlot: false
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * pages / <= Plot
		 * ```
		 */
		pages() {
			return [
				this.Plot()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * json_title_a \
		 * ```
		 */
		json_title_a() {
			return ""
		}
		
		/**
		 * ```tree
		 * json_title_b \
		 * ```
		 */
		json_title_b() {
			return ""
		}
		
		/**
		 * ```tree
		 * json_title_c \
		 * ```
		 */
		json_title_c() {
			return ""
		}
		
		/**
		 * ```tree
		 * layout_shapes /
		 * ```
		 */
		layout_shapes() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * annotations /
		 * ```
		 */
		annotations() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * triangle_annotation_text \
		 * ```
		 */
		triangle_annotation_text() {
			return ""
		}
		
		/**
		 * ```tree
		 * json_comp_range /
		 * ```
		 */
		json_comp_range() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * show_ticks false
		 * ```
		 */
		show_ticks() {
			return false
		}
		
		/**
		 * ```tree
		 * json_temp /
		 * ```
		 */
		json_temp() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * data_demo false
		 * ```
		 */
		data_demo() {
			return false
		}
		
		/**
		 * ```tree
		 * plot_title \
		 * ```
		 */
		plot_title() {
			return ""
		}
		
		/**
		 * ```tree
		 * label? \
		 * ```
		 */
		@ $mol_mem
		label(next?: any) {
			if ( next !== undefined ) return next as never
			return ""
		}
		
		/**
		 * ```tree
		 * Label $mol_view sub / <= label?
		 * ```
		 */
		@ $mol_mem
		Label() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.label()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * mousemove null
		 * ```
		 */
		mousemove() {
			return null as any
		}
		
		/**
		 * ```tree
		 * Root $mol_view
		 * 	dom_name \div
		 * 	event * mousemove <= mousemove
		 * ```
		 */
		@ $mol_mem
		Root() {
			const obj = new this.$.$mol_view()
			
			obj.dom_name = () => "div"
			obj.event = () => ({
				mousemove: this.mousemove()
			} as Record< string, any >)
			
			return obj
		}
		
		/**
		 * ```tree
		 * draw null
		 * ```
		 */
		draw() {
			return null as any
		}
		
		/**
		 * ```tree
		 * Plot $mol_page
		 * 	title <= plot_title
		 * 	body /
		 * 		<= Label
		 * 		<= Root
		 * 	auto <= draw
		 * ```
		 */
		@ $mol_mem
		Plot() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.plot_title()
			obj.body = () => [
				this.Label(),
				this.Root()
			] as readonly any[]
			obj.auto = () => this.draw()
			
			return obj
		}
	}
	
}

